import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, FormGroup, FormInput, Button } from "shards-react";
import { Formik } from 'formik';
import axios from 'axios';

function getLoginError(error) {
    if (!error.response) {
        return {
            title: 'Koneksi gagal',
            message: 'Tidak dapat terhubung ke server. Periksa koneksi internet Anda lalu coba lagi.',
            theme: 'danger',
        };
    }

    if (error.response.status === 401) {
        const exitCode = error.response.headers['x-exit'];
        if (exitCode === 'wrongPassword') {
            return {
                title: 'Password salah',
                message: 'Password Igracias yang Anda masukkan tidak sesuai. Silakan coba lagi.',
                theme: 'danger',
            };
        }
        if (exitCode === 'wrongUsername') {
            return {
                title: 'Username salah',
                message: 'Username Igracias tidak ditemukan atau tidak valid.',
                theme: 'danger',
            };
        }
        if (exitCode === 'wrongServer') {
            return {
                title: 'Server SSO bermasalah',
                message: 'Layanan SSO Telkom University sedang tidak tersedia. Coba beberapa saat lagi.',
                theme: 'warning',
            };
        }
        if (exitCode === 'accountSetupFailed') {
            return {
                title: 'Akun belum terdaftar',
                message: 'Login SSO berhasil, tetapi akun Anda belum ditemukan di sistem TA1. Hubungi admin prodi atau lab riset.',
                theme: 'warning',
            };
        }
        return {
            title: 'Login gagal',
            message: 'Username atau password Igracias salah. Periksa kembali data login Anda.',
            theme: 'danger',
        };
    }

    if (error.response.status >= 500) {
        return {
            title: 'Kesalahan server',
            message: 'Terjadi gangguan pada server aplikasi. Silakan coba lagi atau hubungi admin.',
            theme: 'danger',
        };
    }

    return {
        title: 'Login gagal',
        message: 'Proses login tidak berhasil. Silakan coba lagi.',
        theme: 'danger',
    };
}

function LoginErrorAlert({ error, onDismiss }) {
    if (!error) return null;

    const themeClass = error.theme === 'warning' ? 'alert-warning' : 'alert-danger';

    return (
        <div className={`alert ${themeClass} alert-dismissible mb-3`} role="alert">
            <button
                type="button"
                className="close"
                onClick={onDismiss}
                aria-label="Close"
            >
                <span aria-hidden="true">&times;</span>
            </button>
            <strong>{error.title}</strong>
            <p className="mb-0 mt-2">{error.message}</p>
        </div>
    );
}

LoginErrorAlert.propTypes = {
    error: PropTypes.shape({
        title: PropTypes.string.isRequired,
        message: PropTypes.string.isRequired,
        theme: PropTypes.string,
    }),
    onDismiss: PropTypes.func.isRequired,
};

export default function LoginSsoForm({ userType }) {
    const [loginError, setLoginError] = useState(null);

    const handleSubmit = (values, actions) => {
        setLoginError(null);
        axios.post('/entrance/login-sso', {
            username: values.username,
            password: values.password
        }).then(res => {
            if (res.status == 200) window.location = res.data;
            actions.setSubmitting(false);
        }).catch(err => {
            setLoginError(getLoginError(err));
            actions.setSubmitting(false);
        });
    };

    return (
        <div>
            <h4>Login SSO</h4>
            <LoginErrorAlert
                error={loginError}
                onDismiss={() => setLoginError(null)}
            />
            <Formik
                initialValues={{ username: '', password: '' }}
                onSubmit={handleSubmit}
            >
                {props => (
                    <Form onSubmit={props.handleSubmit}>
                        <FormGroup className={loginError ? 'text-danger' : ''}>
                            <label htmlFor="username">Username Igracias</label>
                            <FormInput
                                type="text"
                                invalid={!!loginError}
                                onChange={props.handleChange}
                                onBlur={props.handleBlur}
                                value={props.values.username}
                                name="username"
                                placeholder="Contoh: ahmadanc atau email pegawai"
                            />
                        </FormGroup>
                        <FormGroup className={loginError ? 'text-danger' : ''}>
                            <label htmlFor="password">Password</label>
                            <FormInput
                                type="password"
                                invalid={!!loginError}
                                onChange={props.handleChange}
                                onBlur={props.handleBlur}
                                value={props.values.password}
                                name="password"
                                placeholder="Password Igracias"
                            />
                        </FormGroup>
                        <Button
                            type="submit"
                            block
                            theme="success"
                            disabled={props.isSubmitting}
                        >
                            {props.isSubmitting ? 'Memproses login...' : 'Login'}
                        </Button>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

LoginSsoForm.propTypes = {
    userType: PropTypes.oneOf(['STUDENT', 'LECTURER'])
};
